import $cookie from "@/tools/cookieMethods";
let userInfo = $cookie.getCookie("userInfo")
  ? JSON.parse($cookie.getCookie("userInfo"))
  : {};
export default {
  userInfo,
  defaultIndex: 0,
};
